<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Tags"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/tags'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
             <v-col class="py-0 px-2">
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Nombre</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  solo
                    hide-details="auto"
                    class="input-base"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="stars"
                rules="required"
                v-slot="{ errors }"
              >
               <div class="label-base pb-1">Estrellas</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.stars"
                  label="Estrellas"
                  solo
                    hide-details="auto"
                    class="input-base"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Tipo</div>
                <v-select 
                :error-messages="errors" 
                v-model="data.type" 
                label="Tipo" 
                :items="types"
                solo
                    hide-details="auto"
                    class="input-base"
                    append-icon="$caretDownFormIcon"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Tags",
      title: "Etiquetas",
      types: ['Negative','Positive'],
      data: {
        name: "",
        stars:"",
        type: "",
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Tags.status,
    }),
  },
  watch: {

  },
  methods: {

  },
};
</script>
